import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Layout, Menu, Dropdown, Typography } from 'antd';
import { UserOutlined, LogoutOutlined, SettingFilled} from '@ant-design/icons';
import './Navbar.css'
import { UserContext } from '../UserContext';

const { Header } = Layout;
const { Title } = Typography;

const Navbar = () => {
  const {user, setUser} = useContext(UserContext)

  const logOutHandler = () => {
    localStorage.removeItem('user')
    setUser(null)
  }

  const dropDownMenu = (
    <Menu>
      <Menu.Item key="0">
        <Link to="/admin">
        <SettingFilled /> <span >Settings</span>
        </Link>
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="3">
      <LogoutOutlined />    <span onClick={logOutHandler}>Logout</span>
      </Menu.Item>
    </Menu>
  );

  const nickName = (name) => {
    return name.split(" ")[0]
  }

  return (
      <Header style={{ position: 'fixed', zIndex: 1, width: '100%' }}>
        <div id="navbar">
          <Link to="/">
            <Title>
              Movies & Games
            </Title>
          </Link>
          <ul>
            <Link to="/movies">
              <li>Movies</li>
            </Link>
            <Link to="/games">
              <li>Games</li>
            </Link>
            {
              user ?
              <Dropdown overlay={dropDownMenu} >
                <li className="ant-dropdown-link">
                <UserOutlined />  Hi, {nickName(user.name)}
                </li>
              </Dropdown>
              :
              <>
                <Link to="/login">
                  <li> Login / Register</li>
                </Link>
              </>
            }
          </ul>
        </div>
        
      </Header>
  )
}

export default Navbar